import type {
  IntegrationRequestDetail,
  IntegrationRequestWebhook,
} from '../../../../models/IntegrationRequest';
import { maskedWebhookHeaders } from '../../../../models/WebhookHeaders';
import DetailFields from './DetailFields';
import DetailCard from './DetailCard';

interface RequestWebhookCardProps {
  webhook: IntegrationRequestWebhook;
  statuses: IntegrationRequestDetail['webhookStatuses'];
}

const RequestWebhookCard = ({ webhook, statuses }: RequestWebhookCardProps) => (
  <DetailCard title='Webhook'>
    <DetailFields
      items={[
        { label: 'URL', value: <span className='break-all'>{webhook.url}</span> },
        { label: 'Headers', value: maskedWebhookHeaders(webhook.headerNames) },
        { label: 'Estados', value: statuses.map((status) => status.name).join(', ') || '-' },
      ]}
    />
  </DetailCard>
);

export default RequestWebhookCard;
